import { timeFormatsEnum } from '../enums/time-formats.enum';
import { PreferencesApiModel, UpdatePreferencesApiModel } from '../../../api/users/models/preferences.api.model';
import { dateFormats } from '../data/date-formats';
import { DateFormatModel } from './date-format.model';
import { DataLanguageModel } from './data-language.model';
import { UserCurrency } from '../enums/user-currency';
import { timeFormats } from '../data/time-formats';
import { NotificationPreferenceModel } from './notification-preference.model';

export class PreferencesModel {
    timeFormat: timeFormatsEnum;
    dateFormat: string;
    dateFormatId: number;
    timeZone: string;
    uiLanguage: DataLanguageModel;
    referenceDataLanguage: DataLanguageModel;
    tosAccepted: boolean;
    currency: UserCurrency;
    notificationPreference: NotificationPreferenceModel;
    hasTempPassword: boolean;

    constructor(apiEntity?: PreferencesApiModel) {
        if (apiEntity) {
            this.constructFromApiEntity(apiEntity);
        } else {
            this.constructDefault();
        }
    }

    /**
     * Constructs this model from the provided API entity
     */
    private constructFromApiEntity(apiEntity: PreferencesApiModel): void {
        this.timeFormat = apiEntity.timeFormat.id;
        this.dateFormat = this.getDateFormatByID(apiEntity.dateFormat.id);
        this.dateFormatId = apiEntity.dateFormat.id;
        this.timeZone = apiEntity.timeZone;
        this.uiLanguage = new DataLanguageModel(apiEntity.uiLanguage);
        this.referenceDataLanguage = new DataLanguageModel(apiEntity.referenceDataLanguage);
        this.tosAccepted = apiEntity.tosAccepted;
        this.currency = UserCurrency[apiEntity.currency];
        this.notificationPreference = new NotificationPreferenceModel(apiEntity.notificationPreference);
        this.hasTempPassword = apiEntity.hasTempPassword;
    }

    /**
     * Constructs the default version of this model
     */
    private constructDefault(): void {
        this.timeFormat = null;
        this.dateFormat = null;
        this.timeZone = null;
        this.currency = UserCurrency.USD;
        this.notificationPreference = new NotificationPreferenceModel();
    }

    /**
     * Gets a date format Angular can read
     * based on the provided ID
     */
    private getDateFormatByID(id: number): string {
        const dateFormatEntry: DateFormatModel = dateFormats.find(currentDateFormat => currentDateFormat.id === id);
        const hasDateFormatEntry: boolean = dateFormatEntry !== null && typeof dateFormatEntry === 'object';
        let dateFormat: string = null;

        if (hasDateFormatEntry) {
            dateFormat = dateFormatEntry.value;
        }

        return dateFormat;
    }

    public getDateFormatString(moment: boolean = false, time: boolean = false, timeZone: boolean = false): string {
        const dateFormatModel = dateFormats.find(format => format.id === this.dateFormatId);
        let formatString;
        if (moment) {
            formatString = dateFormatModel.momentFormat;
        } else {
            formatString = dateFormatModel.value;
        }
        if (time) {
            const timeFormatModel = timeFormats.find(format => format.id === this.timeFormat);
            formatString += ' ' + (moment ? timeFormatModel.momentFormat : timeFormatModel.value);
        }
        if (timeZone) {
            formatString += ' z';
        }
        return formatString;
    }

    public toUpdateApiModel(): UpdatePreferencesApiModel {
        return {
            timeFormatId: this.timeFormat,
            dateFormatId: this.dateFormatId,
            timeZone: this.timeZone,
            referenceDataLanguageId: this.referenceDataLanguage.id,
            uiLanguageId: this.uiLanguage.id,
            tosAccepted: this.tosAccepted,
            currency: this.currency,
            notificationPreference: this.notificationPreference.toApiModel()
        };
    }
}
